module.exports = __webpack_public_path__ + "static/media/twicCard.9dcb9252.svg";